import { useState } from 'react'
import { gravatarImage } from '@/utils/common'

/** Gravatar with an initials fallback (gravatar 404s when none → fall back). */
export function AccountAvatar({
  first,
  last,
  email,
  className = 'size-7',
}: {
  first?: string
  last?: string
  email?: string
  /** Size utilities — the row decides how big the avatar sits. */
  className?: string
}) {
  const [errored, setErrored] = useState(false)
  const url = email ? gravatarImage(email) : null
  const initials =
    `${(first?.[0] ?? '').toUpperCase()}${(last?.[0] ?? '').toUpperCase()}` ||
    '?'
  if (!url || errored) {
    return (
      <span
        aria-hidden
        className={`${className} flex flex-none items-center justify-center rounded-full bg-stampede-500 text-[10px] font-semibold text-white`}
      >
        {initials}
      </span>
    )
  }
  return (
    <img
      src={url}
      alt=""
      aria-hidden
      loading="lazy"
      onError={() => {
        setErrored(true)
      }}
      className={`${className} flex-none rounded-full object-cover`}
    />
  )
}
